import React, { useState , useEffect} from "react";
import {
  GoogleMap,
  LoadScript,
  DirectionsRenderer,
} from "@react-google-maps/api";

function GoogleMaps({origin , destination}) {
  const containerStyle = {
    width: "100%",
    height: "190px",
    marginLeft : "20px"
  };

  const mapOptions = {
    mapTypeControl: false, 
    streetViewControl: false,
    zoomControl: false, 
    disableDoubleClickZoom: true, 
    scrollwheel: false, 
    draggable: false,
  };

  const directionsRendererOptions = {
    polylineOptions: {
      strokeColor: "#4285F4", 
      strokeOpacity: 1.0, 
      strokeWeight: 3, 
    },
  };

  const [directionsResponse, setDirectionsResponse] = useState(null);

  const mapCenter = {
    lat: (origin.latitude + destination.latitude) / 2,
    lng: (origin.longitude + destination.longitude) / 2,
  };

  useEffect(() => {
    if(window.google && window.google.maps){
      fetchDirections();
    }
  },[origin , destination]
)

  const fetchDirections = () => {
    const directionsService = new window.google.maps.DirectionsService();
    directionsService.route(
      {
        origin: new window.google.maps.LatLng(origin.latitude, origin.longitude),
        destination: new window.google.maps.LatLng(
          destination.latitude,
          destination.longitude
        ),
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          setDirectionsResponse(result);
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );
  };


  return (
  
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={mapCenter}
            zoom={25}
            options={mapOptions}
          >
            {directionsResponse && (
              <DirectionsRenderer
                directions={directionsResponse}
                options={directionsRendererOptions}
              />
            )}
          </GoogleMap>
  
  );
}

export default GoogleMaps;

